(function() {
    'use strict';

    angular
        .module('mVtasWebApp')
        .controller('UsuariologDialogController', UsuariologDialogController);

    UsuariologDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'Usuariolog'];

    function UsuariologDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, Usuariolog) {
        var vm = this;

        vm.usuariolog = entity;
        vm.clear = clear;
        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;
        vm.save = save;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.usuariolog.id !== null) {
                Usuariolog.update(vm.usuariolog, onSaveSuccess, onSaveError);
            } else {
                Usuariolog.save(vm.usuariolog, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('mVtasWebApp:usuariologUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }

        vm.datePickerOpenStatus.fecha = false;

        function openCalendar (date) {
            vm.datePickerOpenStatus[date] = true;
        }
    }
})();
